import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "hide",
  "use": "hide-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"hide\"><path d=\"M22 12l-4.722 4.048a8.102 8.102 0 0 1-9.328.865l1.996-1.497a3.962 3.962 0 0 0 5.908-4.431L18.5 9zm-1.7-5.6l-16 12-.6-.8 2.578-1.934L2 12l4.722-4.048a8.087 8.087 0 0 1 10.204-.272L19.7 5.6zM8.54 13.97l6.321-4.741A3.956 3.956 0 0 0 12 8a4 4 0 0 0-4 4 3.904 3.904 0 0 0 .54 1.97z\" data-name=\"1\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hide.svg
// module id = 7eqN
// module chunks = 1